import { render, staticRenderFns } from "./ChangeBasemap.vue?vue&type=template&id=a4b9803a&scoped=true"
import script from "./ChangeBasemap.vue?vue&type=script&lang=js"
export * from "./ChangeBasemap.vue?vue&type=script&lang=js"
import style0 from "./ChangeBasemap.vue?vue&type=style&index=0&id=a4b9803a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b9803a",
  null
  
)

export default component.exports